import React, { useState, useCallback } from 'react';
import { ISaveUntestedDialogResult } from 'types/dialogs';
import SaveUntestedDialog from './SaveUntestedDialog';

const useSaveUntestedDialog = () => {
	const [saveUntestedDialogJsx, setSaveUntestedDialogJsx] =
		useState<React.JSX.Element | null>(null);

	const openSaveUntestedDialog = useCallback(
		() =>
			new Promise<ISaveUntestedDialogResult>((resolve) => {
				setSaveUntestedDialogJsx(
					<SaveUntestedDialog
						onClose={(res) => {
							setSaveUntestedDialogJsx(null);
							resolve(res);
						}}
					/>
				);
			}),
		[]
	);

	return { saveUntestedDialogJsx, openSaveUntestedDialog };
};

export default useSaveUntestedDialog;
